import { IoWarningOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { PiTrashFill } from 'react-icons/pi';
import { ActionIcon, Badge, Button, Popover, Text, Title } from 'rizzui';
import cn from '../../utils/classNames';

type DeletePopoverProps = {
    title: string;
    description: string;
    warningText?: string | null;
    onDelete: () => void;
    size?: string | number;
    className?: string;
    actionIconClassName?: string;
    Icon?: React.ReactNode;
    noBorder?: boolean;
    placement?: 'top' | 'right' | 'bottom' | 'left';
};

export default function DeletePopover({
    title,
    description,
    warningText = null,
    onDelete,
    size = 20,
    className,
    actionIconClassName,
    Icon,
    noBorder = false,
    placement = 'left'
}: DeletePopoverProps) {
    return (
        <Popover placement={placement} overlayClassName={cn('z-[1000] ',[className])}>
            <Popover.Trigger>
                <ActionIcon
                    size="sm"
                    variant={noBorder ? 'solid' : 'outline'}
                    aria-label={'Delete Item'}
                    className={cn([actionIconClassName, `cursor-pointer ${noBorder ? '' : 'hover:!border-gray-900 hover:text-gray-700'} bg-red`])}
                >
                    {Icon ?? <MdDeleteOutline className={noBorder ? 'h-6 w-6' : 'h-4 w-4'} color='white' />}
                </ActionIcon>
            </Popover.Trigger>
            <Popover.Content className="z-[1000]">
                {({ setOpen }) => (
                    <div className="w-56 pb-2 pt-1 text-center rtl:text-right">
                        <Title
                            as="h6"
                            className="mb-0.5 flex justify-center items-center text-sm text-gray-700"
                        >
                            <PiTrashFill className="me-1 h-[17px] w-[17px]" /> {title}
                        </Title>

                        <div className="flex justify-center">
                            <IoWarningOutline className="text-yellow-500" size={30} />
                        </div>

                        <Text className="mb-2 leading-relaxed text-gray-500">
                            {description}
                        </Text>
                        {warningText ? (
                            <div className="mb-2 flex justify-center">
                                <Badge
                                    variant="flat"
                                    size="sm"
                                    className="rounded-lg border border-yellow-300 bg-yellow-50 text-sm text-yellow-900"
                                >
                                    {warningText}
                                </Badge>
                            </div>
                        ) : null}
                        <div className="flex items-center justify-center">
                            <Button size="sm" variant="outline" className="h-7 me-5" onClick={() => setOpen(false)}>
                                No
                            </Button>
                            <Button size="sm" color='danger' className="ms-1 me-1.5 h-7" onClick={onDelete}>
                                Sí
                            </Button>
                        </div>
                    </div>
                )}
            </Popover.Content>
        </Popover>
    );
}
